<template>
  <div class="hint-block">
    <div
      class="title"
      @click="hintOpened = !hintOpened"
    >
      {{ title }}
      <chevron-animated
        :reverse="hintOpened"
      />
    </div>

    <div :class="['description', {opened: hintOpened}]">
      {{ description }}<br>
      <div v-if="secondary">
        <span>Расположение:</span>
        {{ secondary }}
      </div>
    </div>
  </div>
</template>

<script>
import ChevronAnimated from '../../../assets/icons/chevron-animated';

export default {
  name: 'hint-block',

  components: {
    ChevronAnimated
  },

  props: {
    title: {
      type: String,
      required: true,
    },

    description: {
      type: String,
      required: true
    },

    secondary: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      hintOpened: false
    }
  }
};
</script>

<style lang="scss">
.hint-block {
  position: relative;
  overflow: hidden;
  cursor: pointer;

  .title {
    display: flex;
    align-items: center;
    color: $blue;
    font-size: 14px;
    line-height: 16px;

    & > svg {
      color: $blue;
      width: 14px;
      height: 14px;
      margin-left: 4px;
    }
  }

  .description {
    height: 0;
    margin-top: 0;
    font-size: 12px;
    line-height: 18px;
    color: $gray;

    div > span {
      color: $black;
    }

    &.opened {
      height: auto;
      margin-top: 7px;
    }
  }
}
</style>